import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';
import * as moment from 'moment'


@Component({
  selector: 'edit-vehicle-inventory',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="950" title="Liberación de Vehículo" *ngIf="opened" (close)="onClose()">
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">
        <div class="row">
          <div class="col-xs-4 col-sm-4 example-col">
            <div class="col-xs-12 col-sm-12 example-col">
                <images-scrollview [id]="f.id.value"></images-scrollview> 
            </div>                        
          </div>
          <div class="col-xs-8 col-sm-8 example-col">

            <div class="row" style="padding-bottom: 16px">
              <div class="col-xs-4 col-sm-4 example-col">
                  <kendo-label text="Folio de inventario:"></kendo-label>
                  <p class="data-info k-color-error right"><b>{{this.form.value.sku_inv}}</b></p>
              </div>    
              <div class="col-xs-4 col-sm-4 example-col">
                  <kendo-label text="Folio de expediente:"></kendo-label>
                  <p class="data-info k-color-error right"><b>{{this.form.value.sku_exp}}</b></p>
              </div>
              <div class="col-xs-4 col-sm-4 example-col">
                  <kendo-label text="Fecha de entrada:"></kendo-label>
                  <p class="data-info k-color-info">{{intl.formatDate(this.form.value.entry_date, "dd-MMM-yyyy")}}</p>
              </div>
            </div>

            <div class="wrapper">
              <kendo-tabstrip >
                <kendo-tabstrip-tab title="Datos generales">
                  <ng-template kendoTabContent>
                    
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 example-col">
                          <kendo-label text="Autoridad:"></kendo-label>
                          <p class="data-info k-color-info">{{this.form.value.authority_abbreviation}} - {{this.form.value.authority_name}}</p>
                      </div>
                      <div class="col-xs-4 col-sm-4 example-col">
                          <kendo-label text="Depósito:"></kendo-label>
                          <p class="data-info k-color-info">{{this.form.value.deposit_name}}</p>
                      </div>         
                      <div class="col-xs-8 col-sm-8 example-col">
                          <kendo-label text="Tipo de vehículo:"></kendo-label>
                          <p class="data-info k-color-info">{{this.form.value.vehicle_type_name}}</p>                  
                      </div>                      
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Marca:"></kendo-label>
                          <p class="data-info k-color-info">{{this.form.value.marck}}</p>
                      </div>    
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Color:"></kendo-label>
                          <p class="data-info k-color-info">{{this.form.value.color}}</p>
                      </div>
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Placas:"></kendo-label>
                          <p class="data-info k-color-info">{{this.form.value.plaque}}</p>
                      </div>
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Número de serie:"></kendo-label>
                          <p class="data-info k-color-info">{{this.form.value.serie}}</p>
                      </div>
                    </div>

                  </ng-template>
                </kendo-tabstrip-tab>
                <kendo-tabstrip-tab title="Liberación" [selected]="true">
                  <ng-template kendoTabContent>

                    <div class="row">
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Costo de pensión:"></kendo-label>
                          <p class="data-info k-color-success right">{{intl.formatNumber(this.form.value.cost_pension, "c2")}}</p>
                      </div>
                      <div class="col-xs-4 col-sm-4 example-col">
                          <kendo-label text="Costo por día:"></kendo-label>
                          <p class="data-info k-color-success right">{{intl.formatNumber(this.form.value.vehicle_type_fee, "c2")}}</p>
                      </div>
                      <div class="col-xs-2 col-sm-2 example-col">
                          <kendo-label text="Días:"></kendo-label>
                          <p class="data-info k-color-success right">{{this.form.value.days}}</p>                  
                      </div>                      
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Costo de grúa:"></kendo-label>
                          <p class="data-info k-color-success right">{{intl.formatNumber(this.form.value.cost_crane, "c2")}}</p>            
                      </div>
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Fecha de salida:"></kendo-label>
                          <kendo-textbox-container>
                            <kendo-datepicker formControlName="output_date" [format]="'dd-MMM-yyyy'" (valueChange)="outputDateValueChange($event)"></kendo-datepicker>
                          </kendo-textbox-container>
                          <div *ngIf="f.output_date.invalid && (f.output_date.dirty || f.output_date.touched)">                  
                            <div *ngIf="f.output_date.errors">
                              <kendo-formerror *ngIf="f.output_date.errors.required">
                                Error: Campo requerido.
                              </kendo-formerror>
                            </div>   
                          </div>
                      </div>                         
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Subtotal:"></kendo-label>
                          <p class="data-info k-color-success right">{{intl.formatNumber(this.form.value.cost_subtotal, "c2")}}</p>
                      </div>
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Autoriza:"></kendo-label>
                          <dynamic-dropdownlist formControlName="id_person" [table]="'persons'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
                      </div>                                     
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="I. V. A.:"></kendo-label>
                          <p class="data-info k-color-success right">{{intl.formatNumber(this.form.value.cost_iva, "c2")}}</p>
                      </div> 
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Estatus:"></kendo-label>
                          <dynamic-dropdownlist formControlName="id_vehicle_status" [table]="'vehicles_status'" [valueField]="'id'" [textField]="'name'" [showAll]="true" [extraFilter]="[{field: 'id', operator: 'in', value: '3,4'}]"></dynamic-dropdownlist>                                                 
                      </div>                      
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Costo Total:"></kendo-label>
                          <p class="data-info k-color-success right">{{intl.formatNumber(this.form.value.cost_total, "c2")}}</p>  
                      </div>
                      <div class="col-xs-6 col-sm-6 example-col" *ngIf="this.form.value.id_vehicle_status == 4">
                          <kendo-label text="Cliente:"></kendo-label>
                          <dynamic-dropdownlist formControlName="id_customer" [table]="'customers'" [valueField]="'id'" [textField]="'name'" [showAll]="true" (selected)="customerSelected($event)"></dynamic-dropdownlist>                                                 
                      </div>
                      <div class="col-xs-6 col-sm-6 example-col" *ngIf="this.form.value.id_vehicle_status == 3">
                          <kendo-label text="Forma de pago:"></kendo-label>
                          <dynamic-dropdownlist formControlName="id_payment_type" [table]="'payments_types'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
                      </div>                                                                   
                      <div class="col-xs-3 col-sm-3 example-col">
                          <kendo-label text="Porcentaje:"></kendo-label>
                          <kendo-textbox-container>
                            <kendo-numerictextbox formControlName="percent" [format]="'n2'" [min]="0" [max]="100" [step]="5" [autoCorrect]="true" (valueChange)="percentValueChange($event)"></kendo-numerictextbox>
                          </kendo-textbox-container> 
                          <div *ngIf="f.percent.invalid && (f.percent.dirty || f.percent.touched)">                  
                            <div *ngIf="f.percent.errors">
                              <kendo-formerror *ngIf="f.percent.errors.required">
                                Error: Campo requerido.
                              </kendo-formerror>
                            </div>   
                          </div>
                          <!--<p class="data-info k-color-success right">{{intl.formatNumber(this.form.value.cost_discount_perc, "p2")}}</p>-->
                      </div>
                      <div class="col-xs-3 col-sm-3 example-col">
                          <kendo-label text="Descuento:"></kendo-label>
                          <p class="data-info k-color-success right">{{intl.formatNumber(this.form.value.cost_discount, "c2")}}</p>  
                      </div>
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Núm. de factura:"></kendo-label>
                          <kendo-textbox-container>
                            <kendo-textbox formControlName="invoice" [clearButton]="true" controlTrim></kendo-textbox>
                          </kendo-textbox-container>
                      </div>                           
                      <div class="col-xs-6 col-sm-6 example-col">
                          <kendo-label text="Pagado:"></kendo-label>
                          <kendo-textbox-container>
                            <kendo-numerictextbox formControlName="cost_paid" [format]="'c2'" [min]="0" [autoCorrect]="true" (valueChange)="numericValueChange($event)"></kendo-numerictextbox>
                          </kendo-textbox-container> 
                          <div *ngIf="f.cost_paid.invalid && (f.cost_paid.dirty || f.cost_paid.touched)">                  
                            <div *ngIf="f.cost_paid.errors">
                              <kendo-formerror *ngIf="f.cost_paid.errors.required">
                                Error: Campo requerido.
                              </kendo-formerror>
                            </div>   
                          </div>              
                      </div>
                    </div>

                  </ng-template>
                </kendo-tabstrip-tab>
              </kendo-tabstrip>
            </div>

            
          </div>
        </div>        
      </div>
    </form> 

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
    p.data-info {
      margin-bottom: 0px;
      // font-weight: bold;
      margin-top: 8px;
      padding: 6px;
      // background-color: #ecf0f1;
      border: 1px solid #ecf0f1;
      min-height: 30px;
    }
    p.right {
      text-align: right;
    }
    .k-numeric-wrap .k-input, k-formatted-value{
      text-align:right
    }
  `],
  providers: [ DatasourceService ]
})
export class EditVehicleInventoryComponent extends CreateEditWindowComponent {

  @Input() table: string = 'vehicles_inventories';

  protected touched = false;

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);
    
  }

  //@Override
  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`,      
      `Folio de expediente: '${dataItem.sku_exp}'`,
      `Marca: '${dataItem.marck}'`,
      `Color: '${dataItem.color}'`,
      `Placas: '${dataItem.plaque}'`
    ].join('\n')

  };

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {    

    const tzDate = ZonedDate.fromUTCDate((dataItem) ? new Date(dataItem.entry_date) : new Date(), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0), 
      'authority_abbreviation': new FormControl((dataItem) ? dataItem.authority_abbreviation: ""),  
      'authority_name': new FormControl((dataItem) ? dataItem.authority_name: ""),  
      'sku_exp': new FormControl((dataItem) ? dataItem.sku_exp: ""),  
      'sku_inv': new FormControl((dataItem) ? dataItem.sku_inv: ""),  
      'vehicle_type_name': new FormControl((dataItem) ? dataItem.vehicle_type_name: ""),  
      'vehicle_type_fee': new FormControl((dataItem) ? dataItem.vehicle_type_fee: ""),  
      'deposit_name': new FormControl((dataItem) ? dataItem.deposit_name: ""),
      'marck': new FormControl((dataItem) ? dataItem.marck: ""),  
      'color': new FormControl((dataItem) ? dataItem.color: ""),  
      'plaque': new FormControl((dataItem) ? dataItem.plaque: ""),
      'serie': new FormControl((dataItem) ? dataItem.serie: ""),
      'entry_date': new FormControl((dataItem) ? new Date(tzDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required),  
      'output_date': new FormControl(new Date(), Validators.required),
      'id_payment_type': new FormControl(0, Validators.required),
      'id_person': new FormControl(1, Validators.required), 
      'id_vehicle_status': new FormControl(3, Validators.required), 
      // 'cost_crane': new FormControl((dataItem) ? dataItem.cost_crane: 0),
      'cost_crane': new FormControl((dataItem) ? ((dataItem.cost_crane != null) ? dataItem.cost_crane : 0): 0),
      'cost_pension': new FormControl(0, Validators.required),
      'cost_subtotal': new FormControl(0, Validators.required), 
      'cost_iva': new FormControl(0, Validators.required),
      'cost_total': new FormControl(0, Validators.required),
      'cost_paid': new FormControl(0, Validators.required),
      'cost_discount': new FormControl(0, Validators.required),
      'percent': new FormControl(0),
      'cost_discount_perc': new FormControl(0, Validators.required),
      'days': new FormControl(0),
      'invoice': new FormControl(""),

      'id_customer': new FormControl(1),
      'credit_days': new FormControl(0),
      'expiration_date': new FormControl(null),
    });    

  };

  // //@Override
  // protected getData(formGroup: FormGroup): Object {

  //   return Object.assign({}, formGroup.value, { 
  //     password: formGroup.value.pass1
  //   });

  // }; 

  //@Override
  public edit(dataItem: any, rowIndex: number = null): void {

    this.mode = 'EDIT';
    this.opened = true;
    this.form = this.getFormGroup(this.currentUser, dataItem);    
    this.outputDateValueChange(this.form.value.output_date);    
  
  }  

  //@Override
  public delete(dataItem: any): void {
    
    this.mode = 'DELETE';
    this.opened = false;

    this.alertService.confirm(`<p>¿Esta seguro que desea cancelar la liberación del sig. registro?</p> ${this.getObjectString(dataItem)}`, () => {

      this.onDelete(dataItem);

    });
    
  }

  //@Override
  protected getData(formGroup: FormGroup): Object {
    
    return Object.assign({}, { 
      id: formGroup.value.id,
      output_date: (this.mode == 'EDIT') ? this.intl.formatDate(formGroup.value.output_date, "yyyy-MM-dd") : null,
      id_person: (this.mode == 'EDIT') ? formGroup.value.id_person : null,
      id_payment_type: (this.mode == 'EDIT' && formGroup.value.id_vehicle_status == 3) ? formGroup.value.id_payment_type : null,
      days: (this.mode == 'EDIT') ? formGroup.value.days : null,
      // cost_crane: (this.mode == 'EDIT') ? formGroup.value.cost_crane : null,
      cost_pension: (this.mode == 'EDIT') ? formGroup.value.cost_pension : null,
      cost_subtotal: (this.mode == 'EDIT') ? formGroup.value.cost_subtotal : null,
      cost_iva: (this.mode == 'EDIT') ? formGroup.value.cost_iva : null,
      cost_total: (this.mode == 'EDIT') ? formGroup.value.cost_total : null,
      cost_paid: (this.mode == 'EDIT') ? formGroup.value.cost_paid : null,
      cost_discount: (this.mode == 'EDIT') ? formGroup.value.cost_discount : null,
      cost_discount_perc: (this.mode == 'EDIT') ? formGroup.value.cost_discount_perc : null,
      // total: (this.mode == 'EDIT') ? formGroup.value.total : null,
      id_vehicle_status: (this.mode == 'EDIT') ? formGroup.value.id_vehicle_status : 2,
      invoice: formGroup.value.invoice,
      id_customer: (this.mode == 'EDIT' && formGroup.value.id_vehicle_status == 4) ? formGroup.value.id_customer : null,
      credit_days: (this.mode == 'EDIT' && formGroup.value.id_vehicle_status == 4) ? formGroup.value.credit_days : null,
      expiration_date: (this.mode == 'EDIT' && formGroup.value.id_vehicle_status == 4) ? this.intl.formatDate(formGroup.value.expiration_date, "yyyy-MM-dd") : null,
    });

  };

  //@Override
  public onSave(): void {
    
    let data : any = this.getData(this.form);
    console.log('data', data)  
    
    // if (data.pass1 != data.pass2){
							
    //   this.alertService.showError('No coinciden las contraseñas.');
    //   return;
      
    // }
    
    this.service.updateRow(this.table, data) 
      .subscribe(
        (res) => {
          console.log("POST Request is successful: ", this.table, data);
          console.log("mode = " + this.mode);

          this.save.emit({mode: this.mode, dataItem: res.data[0]});
          this.opened = false;
        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      ); 

  }

  //@Override
  public onDelete(dataItem: any): void {
    
    let data : any = this.getData(this.form);

    data.id = dataItem.id;
    console.log('data', data)  
    
    this.service.updateRow(this.table, data) 
      .subscribe(
        (res) => {
          console.log("POST Request is successful: ", this.table, data);
          console.log("mode = " + this.mode);

          this.save.emit({mode: this.mode, dataItem: res.data[0]});
          // this.opened = false;
        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );  

  }

  protected numericValueChange(): void {

    let days : number = parseFloat(this.form.value.days);
    let cost_crane : number = parseFloat(this.form.value.cost_crane);
    let cost_pension : number = days * parseFloat(this.form.value.vehicle_type_fee);
    let cost_subtotal : number = cost_crane + cost_pension;
    let cost_iva : number = cost_subtotal * 0.16;
    let cost_total : number = cost_crane + cost_pension + cost_iva;
    
    if(this.touched == false){
      this.form.patchValue({      
        cost_paid: cost_total,
      });
      this.touched = true;
    }

    let cost_paid : number = parseFloat(this.form.value.cost_paid);
    let cost_discount : number = cost_total - cost_paid;
    let cost_discount_perc : number = cost_discount / cost_total;
    let percent : number = cost_discount_perc * 100;

    this.form.patchValue({      
      cost_pension: cost_pension,
      cost_subtotal: cost_subtotal,
      cost_iva: cost_iva,
      cost_total: cost_total,
      cost_discount: cost_discount,
      percent: percent,
      cost_discount_perc: cost_discount_perc,
    });

  }

  protected percentValueChange(): void {

    let cost_total : number = parseFloat(this.form.value.cost_total);        
    let percent : number = parseFloat(this.form.value.percent);
    
    let cost_discount_perc : number = percent / 100;
    let cost_discount : number = cost_total * cost_discount_perc;
    let cost_paid : number = cost_total - cost_discount;

    this.form.patchValue({      
      cost_paid: cost_paid,
      cost_discount: cost_discount,
      cost_discount_perc: cost_discount_perc
    });

  }

  protected outputDateValueChange(value: number): void {

    // console.log(value);
    var a = moment(value);
    var b = moment(this.form.value.entry_date);
    let days: number = a.diff(b, 'days') + 1

    this.form.patchValue({
      days: days
    });

    this.touched = false;
    this.numericValueChange();

  }

  protected customerSelected(sel) : void {
  
    console.log('VALUE:' + sel.value);
    console.log(sel.item);

    var expiration_date = moment().add(sel.item.credit_days, 'days').format('YYYY-MM-DD');

    this.form.patchValue({
      credit_days: sel.item.credit_days,
      expiration_date: expiration_date
    });

  }

}
